var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowNavRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#002FF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.78 12.504a.691.691 0 0 0 0-1.01l-4.499-4.285a.778.778 0 0 0-1.061 0 .691.691 0 0 0 0 1.011L13.19 12l-3.968 3.78a.691.691 0 0 0 0 1.01.778.778 0 0 0 1.062 0l4.499-4.283-.003-.003Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNavRight);
export default __webpack_public_path__ + "static/media/arrow-nav-right.3fc74e657ef6ea8d229ae907cd997ebf.svg";
export { ForwardRef as ReactComponent };